import { capitalizeFirstLetter } from '../../utils/utils'
import { AcompanharEntrega, VisualizarNota } from '../MyOrders/visualizarNota'

import * as S from './styles'
import { dateTimeFromString } from './utils'

const StepsPedido = ({
  tracking,
  seller,
  pedido,
  isCanceled,
  documento,
  delivery
}) => {
  const stepDataMapping = {
    PEDIDO_EFETUADO: 1,
    AGUARDANDO_LIBERACAO: 2,
    SEPARACAO_DE_PRODUTO: 3,
    EMISSAO_DE_NOTA_FISCAL: 4,
    PEDIDO_EM_TRANSPORTE: 5,
    PEDIDO_ENTREGUE: 6,
    PEDIDO_DEVOLVIDO: 7
  }

  // Filtra o tracking para remover 'PROCESSAMENTO_PEDIDO'
  const filteredTracking = tracking?.filter(
    (e) => e.PedidoSituacao !== 'PROCESSAMENTO_PEDIDO'
  )

  // Se houver PEDIDO_DEVOLVIDO, ignoramos o PEDIDO_ENTREGUE
  const hasDevolvido = filteredTracking?.some(
    (e) => e.PedidoSituacao === 'PEDIDO_DEVOLVIDO'
  )

  const trackingToUse = hasDevolvido
    ? filteredTracking.filter((e) => e.PedidoSituacao !== 'PEDIDO_ENTREGUE')
    : filteredTracking

  const stepsData = []

  for (const status of trackingToUse) {
    const stepId = stepDataMapping[status.PedidoSituacao]
    if (stepId) {
      stepsData[stepId - 1] = {
        Id: status.Id,
        DescricaoStatus: status.DescricaoStatus,
        Motivo: status.Motivo,
        StatusCor: status.StatusCor,
        DataHoraMovimentacao:
          new Date(status.DataHoraMovimentacao).getFullYear() < 1900
            ? ''
            : status.DataHoraMovimentacao,
        stepId
      }
    }
  }

  // Define os passos ativos com base na DataHoraMovimentacao
  stepsData.forEach((item) => {
    item.active = item.DataHoraMovimentacao !== '' ? 1 : 0
  })

  return (
    <S.Wrapper>
      <S.SteptsList>
        {stepsData.map(
          (
            {
              Id,
              DescricaoStatus,
              DataHoraMovimentacao,
              active,
              stepId,
              StatusCor,
              Motivo
            },
            index
          ) => (
            <S.StepsItem
              key={`${Id}${index}`}
              ativo={active}
              cancelado={isCanceled}
              inicial={stepId === 1}
              entregue={stepId === 6 || stepId === 7}
              devolvido={stepId === 7}
              cores={StatusCor}
              className="StepTracking"
            >
              <div className="StepEtapas">
                <div className="StepLinhaAnterior"></div>
                <div className="StepPosicao"></div>
                <div className="StepLinhaPosterior"></div>
              </div>
              <div className="Informacao">
                <p className="Chamada">
                  {capitalizeFirstLetter(DescricaoStatus)}
                </p>
                <p className="DataHora">
                  {!!DataHoraMovimentacao
                    ? dateTimeFromString(DataHoraMovimentacao)
                    : ''}
                </p>
                <p className="LinkAcesso">
                  {(stepId === 2 || stepId === 3) && Motivo && (
                    <p className="Motivo">{capitalizeFirstLetter(Motivo)}</p>
                  )}
                  {stepId === 4 && !isCanceled && (
                    <VisualizarNota
                      seller={seller}
                      pedido={pedido}
                      documento={documento}
                    />
                  )}
                  {stepId === 5 && !isCanceled && (
                    <AcompanharEntrega seller={seller} delivery={delivery} />
                  )}
                </p>
              </div>
            </S.StepsItem>
          )
        )}
      </S.SteptsList>
    </S.Wrapper>
  )
}

export default StepsPedido
